import { Box, Button, HStack, Input, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { nanoid } from "nanoid";

function AddTodo({ addTodos, colorMode }) {
  const [Texts, setTexts] = useState("");
  const toast = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!Texts) {
      toast({
        position: "top",
        title: "No Content.",
        description: "please fill the All  Inputs.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (Texts) {
      toast({
        position: "top",
        title: "Todo is Added",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
      
    }

    console.log(Texts);
    const todo = {
      id: nanoid(),
        name: Texts,
      status:false,
    };
    addTodos(todo);
    setTexts("");
  };
  return (
    <Box mr={8}>
      <form onSubmit={handleSubmit}>
        <HStack>
          <Input
            placeholder="Enter Todo"
            variant="filled"
            value={Texts}
            onChange={(e) => setTexts(e.target.value)}
          />
          <Button
            colorScheme={colorMode === "light" ? "blue" : "green"}
            m={4}
            p={4}
            type="submit">
            Add Todo's
          </Button>
        </HStack>
      </form>
    </Box>
  );
}

export default AddTodo;
